import { ICSVFormat } from "../../models/csv_format.ts";
import { ILazyAttachment } from "../../models/zip_content.ts";

export const validateAttachments = (
  csv: ICSVFormat,
  attachments: ILazyAttachment[],
): void => {
  for (let i = 1; i <= 5; i++) {
    const attachmentKey = `attachment_name${i}` as keyof ICSVFormat;
    const attachmentName = csv[attachmentKey];

    if (attachmentName !== null && typeof attachmentName === "string") {
      const found = attachments.some(
        (attachment) => attachment.name === attachmentName,
      );
      if (!found) {
        throw new Error(`添付ファイル "${attachmentName}" が見つかりません`);
      }
    }
  }
};
